var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef, useEffect, useState, } from 'react';
import * as S from './HeaderStyles';
import { useDisableBodyScroll, useScrollingUp } from '../../util';
import { getLogoSrc } from './utils/logos';
import { AccountDropdown } from './components/AccountDropdown';
import { AccountMenu } from './components/AccountMenu';
import { SubNavDesktop } from './components/SubNavDesktop/SubNavDesktop';
import { Logo } from './components/Logo';
import { ScreenSize, useScreenSize } from './hooks/useScreenSize';
import { NavArea } from './components/NavArea';
import { WaffleButton } from './components/WaffleButton/WaffleButton';
import { ClaimsButton } from './components/ClaimsButton/ClaimsButton';
export var GlobalHeader = forwardRef(function (_a, fRef) {
    var _b;
    var id = _a.id, menuItems = _a.menuItems, myAccountItems = _a.myAccountItems, //TODO MK - Remove this after merge (backwards compat)
    accountItemGroups = _a.accountItemGroups, _c = _a.logoImageProps, logoImageProps = _c === void 0 ? {} : _c, _d = _a.logoAnchorProps, logoAnchorProps = _d === void 0 ? {} : _d, _e = _a.logoProps, logoProps = _e === void 0 ? {} : _e, claimsButtonProps = _a.claimsButtonProps, myAccountButtonProps = _a.myAccountButtonProps, waffleButtonProps = _a.waffleButtonProps, isLoggedIn = _a.isLoggedIn, userEmail = _a.userEmail, _f = _a.depthOffset, depthOffset = _f === void 0 ? 0 : _f, _g = _a.isSubNav, isSubNav = _g === void 0 ? false : _g, subNavConfig = _a.subNavConfig;
    var _h = useState((_b = menuItems[0]) === null || _b === void 0 ? void 0 : _b.hasChevron), isNavMenuActive = _h[0], setNavMenuActive = _h[1];
    var _j = useState(false), isMyAccountMenuActive = _j[0], setIsMyAccountMenuActive = _j[1];
    var _k = useState(false), isMyAccountMobileMenuActive = _k[0], setIsMyAccountMobileMenuActive = _k[1];
    var screenSize = useScreenSize();
    var onKeyDownEventHandler = function (e) {
        if (e.key === 'Escape') {
            setIsMyAccountMenuActive(false);
        }
    };
    var toggleMyAccountDesktopMenu = function (isOpen) {
        setIsMyAccountMenuActive(isOpen);
    };
    var toggleMyAccountMobileMenu = function (isOpen) {
        setIsMyAccountMobileMenuActive(isOpen);
    };
    var toggleMobileMenu = function () {
        setNavMenuActive(function (prev) { return !prev; });
        setIsMyAccountMobileMenuActive(false);
    };
    var toggleMobileMyAccountMenu = function () {
        setNavMenuActive(false);
        setIsMyAccountMobileMenuActive(function (prev) { return !prev; });
    };
    var genericClickHandler = function (handler, e) { return handler(e); };
    useDisableBodyScroll(isNavMenuActive || isMyAccountMobileMenuActive);
    var isScrollingUp = useScrollingUp(true);
    var showWaffleButton = waffleButtonProps && !claimsButtonProps && isLoggedIn;
    //TODO MK - Remove this logic after hamburger button refactor
    var isNavMenuOpenMobile = function () {
        return isNavMenuActive && screenSize === ScreenSize.Small;
    };
    useDisableBodyScroll(isNavMenuActive || isMyAccountMobileMenuActive);
    useEffect(function () {
        !isScrollingUp && setNavMenuActive(false);
        !isScrollingUp && setIsMyAccountMenuActive(false);
    }, [isScrollingUp]);
    useEffect(function () {
        screenSize === ScreenSize.Large && setIsMyAccountMobileMenuActive(false);
        screenSize === ScreenSize.Small && setIsMyAccountMenuActive(false);
        screenSize === ScreenSize.Small && setNavMenuActive(false);
    }, [screenSize]);
    useEffect(function () {
        !isLoggedIn && setIsMyAccountMobileMenuActive(false);
        !isLoggedIn && setIsMyAccountMenuActive(false);
    }, [isLoggedIn]);
    var handleShowHeader = typeof window === 'undefined' || isScrollingUp || isNavMenuActive;
    //TODO MK - Remove this after merge (backwards compat)
    if (myAccountItems &&
        !(accountItemGroups === null || accountItemGroups === void 0 ? void 0 : accountItemGroups.map(function (g) { return g.id; }).includes('BackwardsCompat'))) {
        accountItemGroups !== null && accountItemGroups !== void 0 ? accountItemGroups : (accountItemGroups = []);
        accountItemGroups.push({
            id: 'BackwardsCompat',
            items: myAccountItems
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Header, { ref: fRef, showHeader: handleShowHeader, depthOffset: depthOffset, isSubNav: isSubNav, id: id },
            React.createElement(S.Container, null,
                React.createElement(S.Branding, { isMyAccountButton: !!myAccountButtonProps, isWaffleButton: !!waffleButtonProps },
                    myAccountButtonProps && !isNavMenuOpenMobile() && (React.createElement(S.MenuButton, __assign({ "aria-label": isMyAccountMenuActive
                            ? 'Close My Account menu'
                            : 'Open My Account menu', iconSrc: isMyAccountMobileMenuActive ? 'CloseX' : 'RoundedUser', variant: "flat", color: "secondary", size: "medium", onClick: isLoggedIn
                            ? function () { return toggleMobileMyAccountMenu(); }
                            : function () {
                                return;
                            } }, myAccountButtonProps))),
                    isNavMenuOpenMobile() && (React.createElement(S.MenuButton, { "aria-label": "Close menu", iconSrc: "CloseX", variant: "flat", color: "secondary", size: "medium", onClick: function () { return toggleMobileMenu(); } })),
                    !(logoProps === null || logoProps === void 0 ? void 0 : logoProps.imageProps) && (React.createElement(S.LogoWrapper, null, logoAnchorProps.onClick ? (React.createElement(S.AsurionLogoButton, { onClick: function (e) {
                            return genericClickHandler(logoAnchorProps.onClick, e);
                        } },
                        React.createElement(S.AsurionLogoImage, __assign({}, logoImageProps, { src: getLogoSrc(logoImageProps.src), alt: logoImageProps.alt || 'logo' })))) : (React.createElement(S.AsurionLogo, __assign({}, logoAnchorProps),
                        React.createElement(S.AsurionLogoImage, __assign({}, logoImageProps, { src: getLogoSrc(logoImageProps.src), alt: logoImageProps.alt || 'logo' })))))),
                    (logoProps === null || logoProps === void 0 ? void 0 : logoProps.imageProps) && React.createElement(Logo, __assign({}, logoProps)),
                    showWaffleButton && screenSize === ScreenSize.Small && (React.createElement(WaffleButton, __assign({}, waffleButtonProps))),
                    myAccountButtonProps &&
                        !isNavMenuOpenMobile() &&
                        !waffleButtonProps &&
                        menuItems &&
                        menuItems.length > 0 && (React.createElement(S.MenuButton, { "aria-label": isNavMenuActive ? 'Close menu 1' : 'Open menu 1', iconSrc: isNavMenuActive ? 'CloseX' : 'HamburgerMenu', variant: "flat", color: "secondary", size: "medium", onClick: function () { return toggleMobileMenu(); } }))),
                React.createElement(S.NavContainer, { isMenuActive: isNavMenuActive || isMyAccountMobileMenuActive },
                    React.createElement(NavArea, { items: menuItems, isNavMenuActive: isNavMenuActive, setNavMenuActive: setNavMenuActive }),
                    screenSize === ScreenSize.Small &&
                        isLoggedIn &&
                        isMyAccountMobileMenuActive && (React.createElement(AccountMenu, { isActive: isMyAccountMobileMenuActive, itemGroups: accountItemGroups, email: userEmail, showClaimsButton: !!claimsButtonProps, toggleDropdown: toggleMyAccountMobileMenu })),
                    React.createElement(S.Actions, { isLoggedIn: isLoggedIn, isMyAccountButton: !!myAccountButtonProps, isMyAccountMobileMenu: isMyAccountMobileMenuActive },
                        showWaffleButton && screenSize === ScreenSize.Large && (React.createElement(WaffleButton, __assign({}, waffleButtonProps))),
                        myAccountButtonProps && (React.createElement(AccountDropdown, __assign({ ariaLabel: "Open My Account menu", toggleDropdown: toggleMyAccountDesktopMenu, showClaimsButton: !!claimsButtonProps, isLoggedIn: isLoggedIn, isSelected: isMyAccountMenuActive, itemGroups: accountItemGroups, email: userEmail }, myAccountButtonProps, { onKeyDown: onKeyDownEventHandler }))),
                        claimsButtonProps && (React.createElement(ClaimsButton, __assign({}, claimsButtonProps, { accountMenuActive: isMyAccountMenuActive }))))))),
        React.createElement(S.Overlay, { isMenuActive: isNavMenuActive || isMyAccountMobileMenuActive, onClick: function () {
                setNavMenuActive(false);
                setIsMyAccountMobileMenuActive(false);
            }, depthOffset: depthOffset }),
        isSubNav && React.createElement(SubNavDesktop, __assign({}, subNavConfig))));
});
